import { Component, inject, signal } from '@angular/core';
import { UnsubscribeBaseModel } from '../../../../base/model/UnsubscribeBase.model';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthserviceService } from '../login-page/authservice.service';
import { FaIconComponent } from '@fortawesome/angular-fontawesome';
import { faSpinnerThird } from '@fortawesome/pro-solid-svg-icons';
import { CompoApp } from '../../../../services/CompoApp';
import { SseSingletonService } from '../../../../services/sse/sse-singleton.service';
import { TranslateModule } from '@ngx-translate/core';

import { filter, map, takeUntil } from 'rxjs/operators';
import { ButtonComponent } from '../../../globals/button/button/button.component';
import { AuthPageCommonComponent } from '../auth-page-common.component';
import { USER_ID, USER_ORG_ID } from '../../../../shared.app.rights.context';

@Component({
  selector: 'cp-keycloak-session-page',
  templateUrl: './keycloak-session-page.component.html',
  imports: [
    AuthPageCommonComponent,
    FaIconComponent,
    TranslateModule,
    ButtonComponent
  ],
  styleUrls: ['./keycloak-session-page.component.scss']
})
export class KeycloakSessionPageComponent extends UnsubscribeBaseModel {

  protected readonly faSpinnerThird = faSpinnerThird;
  private readonly REALM_ENDPOINT_PATH = 'rkn'; // is the path from the backend - case-sensitive!

  private activatedRoute = inject(ActivatedRoute);
  private router = inject(Router);
  private app = inject(CompoApp);
  private sseSingletonService = inject(SseSingletonService);
  private authService = inject(AuthserviceService);

  inProgress = signal<boolean>(false);
  sessionUuid = signal<string>('');

  constructor() {
    super();

    this.activatedRoute.params
      .pipe(
        takeUntil(this.unSubscribe$),
        filter(params => !!params),
        map(params => params['uuid']),
        filter(uuid => !!uuid)
      ).subscribe({
      next: sessionUuid => {
        this.startSession(sessionUuid);
      },
      error: err => {
        this.inProgress.set(false);
        this.sseSingletonService.disconnect();
      }
    });
  }

  startSession(sessionUuid: string) {
    this.inProgress.set(true);
    this.authService.keycloak(sessionUuid, this.REALM_ENDPOINT_PATH)
      .subscribe({
        next: result => {
          this.inProgress.set(false);
          if (!result?.token) {
            return;
          }
          this.authService.initAccessModeFromRoleId(result.selectedUserRoleId);
          if (result.roleCount <= 1) {
            USER_ID.next(this.app.data.getUser()?.id);
            USER_ORG_ID.next(result.user.organization?.id || result.user.orgId);
          }
          this.sseSingletonService.disconnect();
          this.sseSingletonService.connect();

          if (result.roleCount > 1) {
            this.router.navigate(['/selectRole'], { queryParams: { roleCount: result.roleCount } });
          } else {
            this.app.on.loginTrigger.next(this.app.data.getUser());
            this.router.navigate(['/home/prozesse/jobs']);
          }
        },
        error: err => {
          this.inProgress.set(false);
        }
      });
  }

  onManualRetryClick() {
    if (!!this.sessionUuid() && !this.inProgress()) {
      this.startSession(this.sessionUuid());
    }
  }
}
